import styled from 'styled-components';
import {
  containers,
  spacing
} from '@comicrelief/component-library';

const Wrapper = styled.article.attrs({
  'data-test': 'prizes'
})`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.color('grey_light')};
`;

const Container = styled.div`
  width: 100%;
  max-width: ${containers.large};
  margin: ${spacing('xl')} auto 0;
  padding-bottom: ${spacing('xl')};
`;

const Section = styled.section.attrs({
  'data-test': 'prizes-list'
})`
  width: 100%;
  margin: 0 auto ${spacing('l')};
  padding: 0 ${spacing('m')};
  max-width: ${containers.large};
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    padding: 0 ${spacing('xxl')};
  }
`;

const Grid = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: ${spacing('xl')};
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Items = styled.div.attrs({
  'data-test': 'prizes-item'
})`
  margin: ${spacing('md')} 0;
  width: 100%;
  text-align: left;
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    margin: ${spacing('md')};
    /* 0.5 to fix ie11 bug */
    width: calc(100% / 3 - 2.05rem);
  }
    
  // Constrain the ratio of the image, without this
  // the cards look odd when they are in a row
  // and they don't have the exact same proportions
   div > img {
    aspect-ratio: 16/9;
    object-fit: cover;
  }
`;

const Title = styled.div`
  margin: ${spacing('m')} auto;
  padding-left: ${spacing('md')};
  max-width: ${containers.medium};
  @media ${({ theme }) => theme.allBreakpoints('L')} {
    margin: 0 auto ${spacing('m')};
    padding-left: ${spacing('xl')};
  }
`;

const Closed = styled.div`
  img {
    filter: grayscale(1);
  }
`;

const Live = styled.div`
  height: 100%;
  a > div div {
    position: relative;
  }
`;

export {
  Wrapper,
  Container,
  Grid,
  Items,
  Section,
  Title,
  Closed,
  Live
};
